import React, { useEffect, useState, useContext, useLayoutEffect } from "react";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../../../provider/ServiceProvider";
import URLstateContext from "../../../../provider/CommonContext";
import "./SchemeTable.css";
function SchemeTable() {
  const { BaseURL } = useContext(URLstateContext);
  const [navrequest, setNavRequest] = useState("1");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    GetPostMethodData(BaseURL + "GetAumAndFoliocount", {
      IICategory: navrequest,
    }).then((responseData) => {
      // console.log(responseData, "responseData");
      if (responseData.data != null && responseData.data.length > 0) {
        setData(DecryptAESdata(responseData.data));
        // console.log(DecryptAESdata(responseData.data));
      }
    });
  }, [BaseURL]);

  const LargeAndMidcapFund = ["JM Large & Mid Cap Fund"]
  const FlexicapFund = ["JM Flexi Cap Fund"];
  const MidcapFund = ["JM Mid Cap Fund"];
  const ValueFund = ["JM Value Fund"];
  const ELSSTaxSaverFund = [
    "JM ELSS - Tax Saver Fund",
  ];
  const LargeCapFund = ["JM Large Cap Fund"];
  const FocusedFund = ["JM Focused Fund"];
  const AggressiveHybridFund = [
    "JM Aggressive Hybrid Fund",
  ];
  const ArbitrageFund = ["JM Arbitrage Fund"];
  const SmallcapFund = ["JM Small Cap Fund"];
  const MultiAssetAllocationFund = ["JM Multi Asset Allocation Fund"]

  // const fundNames = ["JM Flexicap Fund", "JM Midcap Fund", "JM Value Fund", "JM ELSS Tax Saver Fund (Formerly known as JM Tax Gain Fund)", "JM Large Cap Fund", "JM Focused Fund"]

  // Find the data for the identified fund
  //   const fundData = data.find(item => item.FundName === fundNames);

  return (
    <>
      {ArbitrageFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended scheme investing arbitrage opportunities
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Arbitrage Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>
                      {/* <MyTable /> */}

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Equity and Equity related instruments including Equity
Derivatives including stock futures and stock options#

                            </td>
                            <td>65%</td>
                            <td>100%</td>
                          </tr>
                           <tr>
                            <td>
                              Certificate of deposits (CDs) / Government securities with maturity upto 1 year (including Repo on G-sec/ TREPS) / Units of Liquid Fund (including Liquid ETFs) / Money Market Fund / Overnight Fund or Schemes having Macaulay Duration of less than 1 year

                            </td>
                            <td>0%</td>
                            <td>35%</td>
                          </tr>
                          <tr>
                            <td>
                              ETCDs / Units of Mutual Fund (including Gold ETF & Silver ETF)^
                            </td>
                            <td>0%</td>
                            <td>35%</td>
                          </tr>
                        </tbody>
                      </table>

                      <div>
                        #The notional value exposure in derivatives securities
                        would be reckoned for the purposes of the specified
                        limits.
                        <div>
                          ^Any other such security as may be permitted by SEBI/ RBI from time to time. 
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The investment objective of the Scheme is to generate income
                    through arbitrage opportunities emerging out of mispricing
                    between the cash market and the derivatives market and
                    through deployment of surplus cash in fixed income
                    instruments. There can be no assurance that the investment
                    objective of the scheme will be realized. The scheme does
                    not guarantee/ indicate any returns. Investors are required
                    to read all the scheme related information carefully
                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {FocusedFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open-ended equity scheme investing in maximum of 30 stocks of large cap, mid cap and small cap companies
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Focused Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Equity and Equity related instruments*</td>
                            <td>80%</td>
                            <td>100%</td>
                          </tr>
                          <tr>
                            <td>Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds^</td>
                            <td>0%</td>
                            <td>20%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>*Subject to overall limit of 30 stocks.
                        <div>^Any other security as may be permitted by SEBI/ RBI from time to time.
Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by the SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund. 
</div>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The investment objective of the Scheme is to generate long-term capital appreciation/income by investing in equity and equity related instruments across market capitalization of up to 30 companies.
However there can be no assurance that the investment objective of the Scheme will be realized. The Scheme does not guarantee/indicate any returns. Investors are required to read all the scheme related information carefully.

                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {ELSSTaxSaverFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended scheme with attributes in accordance with Equity Linked Saving Scheme, 2005 notified by Ministry of Finance.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">ELSS – Tax Saver Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Equity and Equity related instruments</td>
                            <td>80%</td>
                            <td>100%</td>
                          </tr>

                          <tr>
                            <td>Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds^</td>
                            <td>0%</td>
                            <td>20%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>^Any other security as may be permitted by SEBI/ RBI from time to time.
                        <div>Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by the SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.</div>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The investment objective is to generate long-term capital growth from a diversified and actively managed portfolio of equity and equity related securities and to enable investors a deduction from total income, as permitted under the Income Tax Act, 1961 from time to time. There can be no assurance that the investment objective of the scheme will be realized. The scheme does not guarantee/ indicate any returns. Investors are required to read all the scheme related information set out in this document carefully.

                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {AggressiveHybridFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended hybrid scheme investing predominantly in
                    equity and equity related instruments.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Aggressive Hybrid Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Equity and Equity related instruments</td>
                            <td>65%</td>
                            <td>80%</td>
                          </tr>

                          <tr>
                            <td>
                              Debt Securities (including Fixed income
                              derivatives and securitized debt*) and money
                              market instruments
                            </td>
                            <td>20%</td>
                            <td>35%</td>
                          </tr>

                          <tr>
                            <td>
                              InvITs / ETCDs / Units of Mutual Fund (including Gold ETF & Silver ETF)^
                            </td>
                            <td>0%</td>
                            <td>15%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        * Allocation in securitized debt will not exceed 10% of
                        the net assets
                        <div>^Any other security as may be permitted by SEBI/ RBI from time to time. Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by the SEBI. </div>
                        <div>The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.</div>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The investment objective of the Scheme is to provide steady current income as well as long term growth of capital.
There can be no assurance that the investment objective of the scheme will be realized. The scheme does not guarantee/ indicate any returns. Investors are required to read all the scheme related information carefully. 

                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {console.log("fundData.MonthlyEndAum AAAAGGGGGGGG",fundData.MonthlyEndAum)}
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {console.log("Testinggggggg")}
                              {console.log("fundData.FolioCount AAAAAAGGGGGGGGG",fundData.FolioCount)}
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {ValueFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended equity scheme following a value investment
                    strategy.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Value Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Equity and Equity related instruments(including
                              equity derivatives)
                            </td>
                            <td>80%</td>
                            <td>100%</td>
                          </tr>

                          <tr>
                            <td>
                              Other Equity and Equity related instruments / Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds^
                            </td>
                            <td>0%</td>
                            <td>20%</td>
                          </tr>
                        
                        </tbody>
                      </table>
                      <div>^Any other security as may be permitted by SEBI/ RBI from time to time. Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    JM Value Fund is an open-ended diversified equity scheme which aims to provide long term capital growth by investing primarily in a well-diversified portfolio of undervalued securities.
However, there can be no assurance that the investment objectives of the Scheme will be realized. The Scheme does not guarantee/ indicate any returns. Investors are required to read all the scheme related information carefully

                  </td>
                </tr>
                {/* {data&&data.map((fundData, index) => (
                  <React.Fragment key={index}>
                    {fundData.FundName === FundName && (
                      <>
                        <tr>
                          <td className="random-text-cell content">
                            Assets under Management 
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.MonthlyEndAum}
                          </td>
                        </tr>
                        <tr>
                          <td className="random-text-cell content">
                            No. of folios 
                          </td>
                          <td className="random-text-cell pos">
                            {fundData.FolioCount}
                          </td>
                        </tr>
                      </>
                    )}
                  </React.Fragment>
                ))} */}
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {LargeCapFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended equity scheme predominantly investing in large cap stocks
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Large Cap Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Equity & equity related instruments of large cap companies*</td>
                            <td>80% </td>
                            <td>100%</td>
                          </tr>

                          <tr>
                            <td>
                              Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds^
                            </td>
                            <td>0%</td>
                            <td>20%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        *The scheme will be investing predominantly in large cap stock as per para no 3.9.1(a) of SEBI Master Circular no. HO/24/13/11(1)2026-IMD-POD-1/I/7602/2026 dated March 20, 2026. Large Cap has been defined as 1st-100th company in terms of full market capitalization.

                        <div>^Any other security as may be permitted by SEBI/ RBI from time to time. Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by the SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.</div>
                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The investment objective of the scheme is to provide optimum capital growth and appreciation.
There can be no assurance that the investment objective of the scheme will be realized. The scheme does not guarantee/ indicate any returns. Investors are required to read all the scheme related information carefully.

                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {/* {fundData.MonthlyEndAum} */}
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {/* {fundData.FolioCount} */}
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {MidcapFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended Equity Scheme predominantly investing in mid cap stocks
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Mid Cap Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Equity and Equity Related Instruments of Mid Cap
                              companies*
                            </td>
                            <td>65%</td>
                            <td>100%</td>
                          </tr>

                          <tr>
                            <td>
                              Equity and Equity Related Instruments other than
                              above
                            </td>
                            <td>0%</td>
                            <td>35%</td>
                          </tr>

                          <tr>
                            <td>
                              Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds^
                            </td>
                            <td>0%</td>
                            <td>35%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>
                        <div>^Any other security as may be permitted by SEBI/ RBI from time to time.</div>
                        <div>Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by the SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.</div>
                        * Investment universe of “Mid Cap”:
                        <br />
                        • The investment universe of “Mid Cap” shall comprise companies as defined by SEBI from time to time. 
                        <br />•	In terms of para 3.9 of SEBI Master Circular no. HO/24/13/11(1)2026- IMD-POD-1/I/7602/2026 dated March 20, 2026, the universe of “MidCap” shall consist of 101st to 250th company in terms of full market capitalization and that the Scheme will be required to adhere the following: <br />
- The list of stocks of Mid Cap companies prepared by AMFI in this regard will be adopted. <br/>
- The said list would be uploaded on the AMFI website and would be updated every six months based on the data as on the end of June and December of each year or periodically as specified by SEBI. <br/>
- Subsequent to any updation in the said list as uploaded by AMFI, the portfolio of the Scheme will be rebalanced within a period of one month.

                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    To provide long-term capital appreciation/income by investing predominantly in Mid-Cap companies.
There is no assurance that the investment objective of the Scheme will be realized.

                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {/* {fundData.MonthlyEndAum} */}
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {/* {fundData.FolioCount} */}
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {FlexicapFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended dynamic equity scheme investing across large cap, mid cap, small cap stocks.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Flexi Cap Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Equity and Equity related instruments</td>
                            <td>65%</td>
                            <td>100%</td>
                          </tr>

                          <tr>
                            <td>
                              Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds^
                            </td>
                            <td>0%</td>
                            <td>35%</td>
                          </tr>
                        </tbody>
                      </table>
                      <div>^Any other security as may be permitted by SEBI/ RBI from time to time. Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by the SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    JM Flexicap Fund is an open-ended diversified equity fund which aims to provide capital appreciation by investing primarily in equity and equity related securities of various market capitalisation. <br />
                    There can be no assurance that the investment objective of the scheme will be realized. 
The scheme does not guarantee/ indicate any returns. Investors are required to read all the scheme related information set out in this document carefully.

                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

      {SmallcapFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open ended equity scheme predominantly investing in small
                    cap stocks.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Small Cap Fund</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                              Equity& Equity related instruments^ of small cap
                              companies$
                            </td>
                            <td>65%</td>
                            <td>100%</td>
                          </tr>
                          <tr>
                            <td>Equity and equity related instruments^ of other than small cap companies</td>
                            <td>0%</td>
                            <td>35%</td>
                          </tr>
                          <tr>
                            <td>Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds*</td>
                            <td>0%</td>
                            <td>35%</td>
                          </tr>
                         
                        </tbody>
                      </table>
                      <div>
                        $Small Cap companies are those companies which are classified as small cap companies by Securities and Exchange Board of India (SEBI) or Association of Mutual Funds in India (AMFI) in terms of market capitalisation. Small Cap Companies as defined by SEBI: 251st company onwards in terms of full market capitalization.
                        <br />

                        *Any other security as may be permitted by SEBI/ RBI from time to time. Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.
                        <br />
                        ^The AMC intends to invest in derivative instruments in accordance with the SEBI (Mutual Funds) Regulations, 2026, as and when opportunities arise in the derivatives markets. The investment in derivatives will not exceed 50% of the net assets of the scheme and will be broadly in line with the investment objective of the Scheme.

                      </div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    The primary objective of the Scheme is to generate long-term capital appreciation by investing predominantly in equity and equity related securities of small cap companies, as defined by SEBI.
However, there is no assurance that the investment objective of the Scheme will be achieved. The Scheme does not guarantee/indicate any returns.


                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}

        {LargeAndMidcapFund.map((FundName, index) => (
   
  <div key={index}>
    <table className="main-table">
      <thead>
        <tr>
          <th className="column-heading">Features of the Scheme</th>
          <th className="column-heading">{FundName}</th>
        </tr>
      </thead>

      <tbody>
        {/* Type */}
        <tr>
          <td className="data-cell content">Type of the Scheme</td>
          <td className="data-cell">
            An open ended equity scheme investing in both large cap and mid cap
            stocks.
          </td>
        </tr>

        {/* Category */}
        <tr>
          <td className="data-cell content">Category of the Scheme</td>
          <td className="data-cell">Large & Mid Cap Fund</td>
        </tr>

        {/* Asset Allocation */}
        <tr>
          <td className="data-cell content">
            Asset Allocation as per SID (in %)
          </td>
          <td className="data-cell">
            <div className="random-heading">Asset Allocation Pattern</div>

            <table className="inner-table">
              <thead>
                <tr>
                  <th rowSpan="2">Instruments</th>
                  <th colSpan="2">
                    Indicative Allocations (% of total assets)
                  </th>
                </tr>
                <tr>
                  <th>Minimum</th>
                  <th>Maximum</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    Equity and Equity related instruments of Large and Mid Cap Companies of which:
                  </td>
                  <td>70%</td>
                  <td>100%</td>
                </tr>

                <tr>
                  <td style={{ paddingLeft: "30px" }}>
                  Large Cap$ Companies
                  </td>
                  <td>35%</td>
                  <td>65%</td>
                </tr>

                <tr>
                  <td style={{ paddingLeft: "30px" }}>
                  Mid Cap$ Companies
                  </td>
                  <td>35%</td>
                  <td>65%</td>
                </tr>

                <tr>
                  <td>
                   Equity and Equity Related Instruments other than above
                  </td>
                  <td>0%</td>
                  <td>30%</td>
                </tr>

                <tr>
                  <td>
                    Money Market Instruments / InvITs/ Gold ETFs / Silver ETFs / Other Liquid Instruments / Units of Domestic Mutual Funds^
                  </td>
                  <td>0%</td>
                  <td>30%</td>
                </tr>
              </tbody>
            </table>

            {/* Notes */}
            <div style={{ marginTop: "10px", fontSize: "13px" }}>
              <p>^Any other security as may be permitted by SEBI/ RBI from time to time. Other Liquid instruments includes cash, bank deposits with Scheduled Commercial Banks, Government Securities, Treasury bills, Repo on Government securities and any other instruments as specified by the SEBI. The scheme may invest in the units of Overnight Fund, Money Market Fund & Liquid Fund.</p>
            
              <p>
                $The investment universe of “Large Cap” and “Mid Cap” shall comprise companies as defined by SEBI from time to time. In terms of SEBI Master Circular:
              </p>
              <ul>
                <li>
                  the universe of “Large Cap” shall consist of 1st to 100th company in terms of full market capitalization;
                </li>
                <li>
                  the universe of “Mid Cap” shall consist of 101st to 250th company in terms of full market capitalization;
                </li>
              </ul>
            </div>
          </td>
        </tr>

        {/* Investment Objective */}
        <tr>
          <td className="random-text-cell content">
            Investment Objective
          </td>
          <td className="random-text-cell">
            The investment objective of the Scheme is to seek long term capital growth through investments in equity and equity related securities of predominantly large cap and mid cap stocks. 
However, there is no assurance that the investment objective of the Scheme will be achieved. The Scheme does not guarantee/indicate any returns.

          </td>
        </tr>

        {/* AUM
        <tr>
          <td className="random-text-cell content">
            Assets under Management as on December 31, 2025 (in Crores)
          </td>
          <td className="random-text-cell pos">404.88</td>
        </tr>

        {/* Folios *
        <tr>
          <td className="random-text-cell content">
            No. of folios as on December 31, 2025
          </td>
          <td className="random-text-cell pos">21597</td>
        </tr> */}

        {Array.isArray(data) && data.length > 0 ? (
  data.map((fundData, index) => (
    <React.Fragment key={index}>
      {fundData.FundName === FundName ? (
        <>
          <tr>
            <td className="random-text-cell content">
              Assets under Management
            </td>
            <td className="random-text-cell pos">
              {fundData.MonthlyEndAum !== null &&
              fundData.MonthlyEndAum !== undefined
                ? fundData.MonthlyEndAum
                : "No data available"}
            </td>
          </tr>

          <tr>
            <td className="random-text-cell content">
              No. of folios
            </td>
            <td className="random-text-cell pos">
              {fundData.FolioCount !== null
                ? fundData.FolioCount
                : "No data available"}
            </td>
          </tr>
        </>
      ) : null}
    </React.Fragment>
  ))
) : (
  <tr>
    <td colSpan="2" className="random-text-cell content">
      No data found
    </td>
  </tr>
)}

      </tbody>
    </table>

    <br /><br /><br />
  </div>
))}

 {MultiAssetAllocationFund.map((FundName, index) => (
        <div key={index}>
          <>
            <table className="main-table">
              <thead>
                <tr>
                  <th className="column-heading">Features of the Scheme</th>
                  <th className="column-heading">{FundName}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="data-cell content">
                    Type of the <br />
                    Scheme
                  </td>
                  <td className="data-cell">
                    An open-ended scheme investing in equity and equity related instruments, debt & money market securities, gold/silver related instruments and other exchange traded commodity derivatives.
                  </td>
                </tr>
                <tr>
                  <td className="data-cell content">Category of the Scheme</td>
                  <td className="data-cell">Multi Asset Allocation</td>
                </tr>
                <tr>
                  <td className="data-cell content">
                    Asset Allocation as per SID (in %)
                  </td>
                  <td className="data-cell">
                    <div>
                      <div className="random-heading">
                        Asset Allocation Pattern
                      </div>

                      <table className="inner-table">
                        <thead>
                          <tr>
                            <th rowspan="2">Types of Instruments</th>
                            <th colSpan="2">
                              Indicative Allocations (%) of Net Assets
                              <table className="sub-inner-table"></table>
                            </th>
                          </tr>
                          <tr>
                            <th>Minimum</th>
                            <th>Maximum</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>
                             Equity and Equity Related Instruments including derivatives and REITs. 
                            </td>
                            <td>35%</td>
                            <td>100%</td>
                          </tr>

                          <tr>
                            <td>
                              Debt Securities and Money Market Instruments including mutual funds units. 
                            </td>
                            <td>10%</td>
                            <td>55%</td>
                          </tr>
                          <tr>
                            <td>Gold/silver related instruments (including ETFs, Sovereign gold deposit schemes) & Exchange Traded Commodity Derivatives (ETCDs) of gold/silver and other commodities as permitted by SEBI from time to time. </td>
                            <td>10%</td>
                            <td>50%</td>
                          </tr>
                          <tr>
                            <td>Units issued by InVITs</td>
                            <td>0%</td>
                            <td>10%</td>
                          </tr>
                          {/* <tr>
                            <td>Units of Mutual Fund Scheme</td>
                            <td>0%</td>
                            <td>10%</td>
                          </tr> */}
                        </tbody>
                      </table>
                      {/* <div>
                        $Small Cap companies are those companies which are
                        classified as small cap companies by Securities and
                        Exchange Board of India (SEBI) or Association of Mutual
                        Funds in India (AMFI) in terms of market capitalisation.
                        Small Cap Companies as defined by SEBI: 251st company
                        onwards in terms of full market capitalization.
                      </div>
                      <br />

                      <div>
                        ^^Money Market instruments includes commercial papers,
                        commercial bills, treasury bills, Government securities
                        having an unexpired maturity up to one year, call or
                        notice money, certificate of deposit, usance bills, and
                        any other like instruments as specified by the Reserve
                        Bank of India from time to time and subject to
                        regulatory approval.
                      </div>
                      <br />

                      <div>
                        *Debt instruments may include securitised debt upto 20%
                        of the debt portfolio of the scheme.
                      </div>
                      <br />

                      <div>
                        ^The Scheme may invest upto 50% of equity assets in
                        equity derivatives instruments as permitted under the
                        SEBI (Mutual Funds) Regulations, 1996 from time to time.
                        The Scheme may use equity derivatives for such purposes
                        as maybe permitted under the SEBI (Mutual Funds)
                        Regulations, 1996, including but not limited for the
                        purpose of hedging and portfolio balancing, based on the
                        opportunities available and subject to guidelines issued
                        by SEBI from time to time. The scheme shall not invest
                        in debt derivative instruments.
                      </div> */}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td className="random-text-cell content">
                    Investment Objective
                  </td>
                  <td className="random-text-cell">
                    To provide long term capital appreciation and generate income by investing in instruments across multiple asset classes viz. Equity, Debt, Gold/silver related instruments and other exchange traded commodity derivatives.

However, there is no assurance that the investment objective of the Scheme will be achieved. The Scheme does not guarantee/indicate any returns.

                  </td>
                </tr>
                {Array.isArray(data) && data.length > 0 ? (
                  data.map((fundData, index) => (
                    <React.Fragment key={index}>
                      {console.log("Fundatataaaaa==>", fundData)}
                      {fundData.FundName === FundName ? (
                        <>
                          <tr>
                            <td className="random-text-cell content">
                              Assets under Management
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.MonthlyEndAum !== null &&
                              fundData.MonthlyEndAum !== undefined
                                ? fundData.MonthlyEndAum
                                : "No data available"}
                            </td>
                          </tr>
                          <tr>
                            <td className="random-text-cell content">
                              No. of folios
                            </td>
                            <td className="random-text-cell pos">
                              {fundData.FolioCount !== null
                                ? fundData.FolioCount
                                : "No data available"}
                            </td>
                          </tr>
                        </>
                      ) : null}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2" className="random-text-cell content">
                      No data found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <br />
            <br />
            <br />
          </>
        </div>
      ))}



    </>
  );
}

export default SchemeTable;
